import { MessageKey } from '../../../models/message/message-key';
import { MessagePatternMap } from '../../../models/message/message-pattern-map';

/**
 * List of initial ticketing error patterns mapped to message keys.
 * Order matters - first match wins.
 */
export const initialTicketingSpecificErrors: MessagePatternMap[] = [
  {
    pattern: 'exchangetransienttokenfortms activity failed',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_TOKEN_EXCHANGE_FAILURE,
  },
  {
    pattern: 'fraudalert',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_FRAUD_ALERT_FAILURE,
  },
  {
    pattern: 'notenoughmiles',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_NOT_ENOUGH_POINTS_FAILURE,
  },
  {
    pattern: 'membernotfound',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_INVALID_ACCOUNT_FAILURE,
  },
  {
    pattern: 'order payment was declined by payment provider',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_CARD_PROCESSING_FAILURE,
  },
  {
    pattern: 'payment declined. unable to process the authorization. please contact bank or use different payment before trying again.',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_CARD_PROCESSING_FAILURE,
  },
  {
    pattern: 'cancelflightredemptioncertificates activity failed',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_ISSUE_TICKETS_NO_CERT_REDEPOSIT_FAILURE,
  },
  {
    pattern: 'ticket is created but not committed to reservation',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_TICKET_ASSOCIATION_FAILURE,
  },
  {
    pattern: 'uc segments detected, ticketing not allowed.',
    messageKey: MessageKey.INITIAL_BOOKING_TICKETING_UC_SEGMENTS_DETECTED_FAILURE,
  },
];
